<template>
  <div class="u-table">
    <!--<h3 class="header">-->
      <!--<span>工单列表</span>-->
      <!--<span class="sub-header">(20/30)</span>-->
    <!--</h3>-->
    <Table
      :columns="columns"
      :data="data"
      :stripe="stripe"
      :border="border"
      :width="width"
      :height="height"
      :max-height="maxHeight"
      :show-header="showHeader"
      :highlight-row="highlightRow"
      :row-class-name="rowClassName"
      :no-data-text="noDataText"
      :no-filtered-data-text="noFilteredDataText"
      :disabled-hover="disabledHover"
      :loading="loading"
      :draggable="draggable"
      @on-row-click="onRowClick"
      @on-row-dblclick="onRowDbClick"
      @on-sort-change="onSortChange"
      @on-select="onSelect"
      @on-select-cancel="onSelectCancel"
      @on-select-all="onSelectAll"
      @on-select-all-cancel="onSelectAllCancel"
      @on-selection-change="onSelectionChange"
      @on-filter-change="onFilterChange"
      ref="table"
    >
      <slot name="t-header" slot="header"></slot>
      <slot name="t-footer" slot="footer"></slot>
    </Table>
  </div>
</template>

<script>
import "@/styles/component/uTable.less";
export default {
  name: "uTable",
  provide() {
    return {
      uTableRoot: this
    };
  },
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    columns: {
      type: Array,
      default() {
        return [];
      }
    },
    width: {
      //表格宽度，单位 px
      type: [Number, String]
    },
    height: {
      //表格高度，单位 px，设置后，如果表格内容大于此值，会固定表头
      type: [Number, String]
    },
    maxHeight: {
      //表格高度，单位 px，设置后，如果表格内容大于此值，会固定表头
      type: [Number, String]
    },
    stripe: {
      //是否显示间隔斑马纹
      type: Boolean,
      default: false
    },
    border: {
      //是否显示纵向边框
      type: Boolean,
      default: false
    },
    showHeader: {
      //是否显示表头
      type: Boolean,
      default: true
    },
    highlightRow: {
      //是否支持高亮选中的行，即单选
      type: Boolean,
      default: false
    },
    rowClassName: {
      //行的 className 的回调方法，传入参数：row：当前行数据 index：当前行的索引
      type: Function,
      default() {
        return "";
      }
    },
    noDataText: {
      //数据为空时显示的提示内容
      type: String
    },
    noFilteredDataText: {
      //筛选数据为空时显示的提示内容
      type: String
    },
    disabledHover: {
      //禁用鼠标悬停时的高亮
      type: Boolean
    },
    loading: {
      //表格是否加载中
      type: Boolean,
      default: false
    },
    draggable: {
      //是否开启拖拽调整行顺序，需配合 @on-drag-drop 事件使用
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    onRowClick(data, index) {
      //单击某一行时触发
      this.$emit("on-row-click", data, index);
    },
    onRowDbClick(data, index) {
      //双击某一行时触发
      this.$emit("on-row-dbclick", data, index);
    },
    onSortChange(column, key, order) {
      //排序时有效，当点击排序时触发
      this.$emit("on-sort-change", column, key, order);
    },
    onSelect(selection, row) {
      this.$emit("on-select", selection, row);
    },
    onSelectCancel(selection, row) {
      this.$emit("on-select-cancel", selection, row);
    },
    onSelectAll(selection) {
      //在多选模式下有效，点击全选时触发
      this.$emit("on-select-all", selection);
    },
    onSelectAllCancel(selection) {
      //在多选模式下有效，点击取消全选时触发
      this.$emit("on-select-all-cancel", selection);
    },
    onSelectionChange(selection) {
      //在多选模式下有效，只要选中项发生变化时就会触发
      this.$emit("on-selection-change", selection);
    },
    onFilterChange(data) {
      //筛选时有效，筛选条件发生变化时触发
      this.$emit("on-filter-change", data);
    },
    exportCsv(params) {
      //将数据导出为 .csv 文件
      this.$refs.table.exportCsv(params);
    }
  }
};
</script>
